import React from 'react';
import Checkbox from '@jetshop/ui/Checkbox';
import { useBooleanFilter } from '@jetshop/core/hooks/Filters/useBooleanFilter';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';

const BooleanFiltersWrapper = styled('div')``;
const BooleanFilterWrapper = styled('div')`
  margin: 10px 0;
  label {
    svg {
      path {
        fill: #333;
      }
    }
    input:focus ~ span {
      border-color: ${theme.colors.buy};
    }
    &:hover {
      input ~ span {
        background-color: #eee;
      }
    }
  }
`;

export function BooleanFilters({ filters, className = '', showTitle = false }) {
  if (!filters) return null;

  const boolFilters = filters.filter(
    (filter) => filter.__typename === 'BooleanFilter'
  );

  if (boolFilters.length === 0) return null;

  return (
    <BooleanFiltersWrapper
      className={`filter bool-filters-wrapper ${className}`}
    >
      {showTitle && <h4 className="title">Produkter</h4>}
      {boolFilters.map((filter) => (
        <BooleanFilter filter={filter} key={filter.id} />
      ))}
    </BooleanFiltersWrapper>
  );
}

function BooleanFilter({ filter }) {
  const { apply } = useBooleanFilter({ filter });
  return (
    <BooleanFilterWrapper className="bool-filter">
      <h4 className="title">
        <Checkbox
          key={filter.id}
          label={filter.name}
          checked={filter.value}
          onChange={(e) => {
            apply({ value: e.currentTarget.checked });
          }}
        />
      </h4>
    </BooleanFilterWrapper>
  );
}
